/**
 * Editor de texto enriquecido (tipo Word) sin dependencias externas.
 * Basado en contentEditable + document.execCommand. Se usa como modal:
 * recibe el HTML inicial y devuelve el HTML editado al guardar.
 */
import React, { useRef, useEffect } from 'react';
import './EditorRico.css';

const EditorRico = ({ titulo, descripcion, initialHtml, onGuardar, onCancelar, guardando }) => {
  const editorRef = useRef(null);

  // Cargar el HTML inicial una sola vez (contentEditable no debe ser controlado
  // por React para no perder la posición del cursor al escribir).
  useEffect(() => {
    if (editorRef.current) editorRef.current.innerHTML = initialHtml || '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cmd = (comando, valor = null) => {
    document.execCommand(comando, false, valor);
    editorRef.current?.focus();
  };

  const handleGuardar = () => {
    const html = editorRef.current?.innerHTML || '';
    onGuardar(html);
  };

  return (
    <div className="er-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancelar(); }}>
      <div className="er-modal">
        <div className="er-header">
          <div>
            <h3>{titulo}</h3>
            {descripcion && <p className="er-desc">{descripcion}</p>}
          </div>
          <button className="er-close" onClick={onCancelar}>×</button>
        </div>

        <div className="er-toolbar">
          <button type="button" title="Negrita" onMouseDown={(e) => { e.preventDefault(); cmd('bold'); }}><b>B</b></button>
          <button type="button" title="Cursiva" onMouseDown={(e) => { e.preventDefault(); cmd('italic'); }}><i>I</i></button>
          <button type="button" title="Subrayado" onMouseDown={(e) => { e.preventDefault(); cmd('underline'); }}><u>U</u></button>
          <span className="er-sep" />
          <button type="button" title="Título de cláusula" onMouseDown={(e) => { e.preventDefault(); cmd('formatBlock', 'H4'); }}>H</button>
          <button type="button" title="Párrafo" onMouseDown={(e) => { e.preventDefault(); cmd('formatBlock', 'P'); }}>¶</button>
          <button type="button" title="Lista con viñetas" onMouseDown={(e) => { e.preventDefault(); cmd('insertUnorderedList'); }}>• Lista</button>
          <span className="er-sep" />
          <button type="button" title="Alinear izquierda" onMouseDown={(e) => { e.preventDefault(); cmd('justifyLeft'); }}>⬅</button>
          <button type="button" title="Centrar" onMouseDown={(e) => { e.preventDefault(); cmd('justifyCenter'); }}>⬌</button>
          <button type="button" title="Justificar" onMouseDown={(e) => { e.preventDefault(); cmd('justifyFull'); }}>☰</button>
          <span className="er-sep" />
          <button type="button" title="Quitar formato" onMouseDown={(e) => { e.preventDefault(); cmd('removeFormat'); }}>✕ formato</button>
        </div>

        <div className="er-editor-wrap">
          <div
            ref={editorRef}
            className="er-editor contrato-clausulas"
            contentEditable
            suppressContentEditableWarning
          />
        </div>

        <div className="er-footer">
          <span className="er-hint">Edita el texto como en Word. Los datos del cliente, valores y firmas siguen siendo automáticos.</span>
          <div className="er-actions">
            <button className="er-btn-cancelar" onClick={onCancelar} disabled={guardando}>Cancelar</button>
            <button className="er-btn-guardar" onClick={handleGuardar} disabled={guardando}>
              {guardando ? 'Guardando…' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorRico;
